
import { BACK, NEXT, SUBMIT } from "../../Constants";

interface FormNavigationInterface {
  isLast: boolean;
  isDisabled?: boolean;
  handleBack?: () => void;
}

const FormNavigation = ({
  isLast,
  isDisabled = false,
  handleBack
}: FormNavigationInterface) => {
  return (
    <>
      <hr />
      <nav>
        <ul className="flex justify-between flex-wrap list-none pl-0">
          <li className="list-none">
            {handleBack && (
              <button
                className="btn-secondary btn-mobile"
                type="button"
                onClick={handleBack}
                disabled={isDisabled}
                data-event-category="click"
                data-event-name="button_click"
                data-event-label="BACK"
              >
                {BACK}
              </button>
            )}
          </li>
          <li className="list-none">
            <input className="btn-primary btn-mobile" type="submit" value={isLast ? SUBMIT : NEXT} disabled={isDisabled} />
          </li>
        </ul>
      </nav>
    </>
  );
};

export default FormNavigation;
